import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Insightimg from "../assests/Insight1.png";
import caseimg from '../assests/1.png'
import caseimg2 from '../assests/2.png'
import {Link} from "react-router-dom";



const Insight2 = () => {
  const dynamicData = [
    {
      id: 1,
      src: caseimg,
      description: "Latest Marketing Tips 2024: How's the Vatavaran?",
      desc:"Would you be interested in knowing what's up in the professional marketing circles and firms who make it big, or are you catching up from the past year .",
    },
    {
      id: 2,
      src: caseimg2,
      description: "Need of the Decade: Full Service Agency Conglomerate",
      desc:"Need of the Decade: Full Service Agency Conglomerate If you're wondering what is a full-service agency conglomerate then read through! And if you feel stuck in deciding whether .."
    }
    // Add more items as needed
  ];

  const options = {
    items: 2,
    loop: false,
    nav: false,
    margin: 50,
    dots:true,
    autoplay: true,
    autoplayTimeout: 30000000000000000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1.1,
    margin: 10,

      },
      600: {
        items: 1.2,
    margin: 10,

      },
      1000: {
        items: 2,
      },
    },
  };

  return (
    <section className="sec-menu">
      <div class="menu d-none d-sm-none d-md-block">
        <div class="menu__item">
          <div class="marquee">
            <div class="marquee__inner">
              <span className="d-block d-sm-none d-md-block">Katsam Media</span>
              <span className="d-block d-sm-none d-md-block">Katsam Media</span>
              <span className="d-block d-sm-none d-md-block">Katsam Media</span>
              <span>Katsam Media</span>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="headcontainer">
          <div class="red-circle"></div>
          <h5 className="headtitle" >
           Katsam Intellect
            <div className="strip"></div>
          </h5>
        </div>

        <div className="col-12 ">
          <div className="silder2">
            <OwlCarousel className="owl-theme" {...options}>
              {dynamicData.map((item) => (
                <>
                <Link to="/blog">
                <div class="item1">
                    <a
                      className="hovercard"
                      href="#0"
                      aria-labelledby="person1"
                    ></a>
                    <img src={item.src} alt="Marketing Agency, full service marketing agency" />
                    <div class="item__overlay1 title-box">
                      <div className="row">
                        <div className="col-md-9 col-lg-10 col-10">
                          <h4 id="person1" aria-hidden="true">
                            {item.description}
                          </h4>
                        </div>
                        <div className="col-lg-2 col-2">
                        <Link to="/blog">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="36"
                            height="32"
                            viewBox="0 0 36 32"
                            fill="none"
                          >
                            <path
                              d="M10.5125 28.3965L34.6592 6.99979"
                              stroke="white"
                            />
                            <path
                              d="M7.29599 24.5082L27.9418 6.42788L16.1893 5.32506"
                              stroke="white"
                              stroke-width="3"
                            />
                          </svg>
                        </Link>
                        </div>
                      </div>

                      <div class="item__body">
                        <p>
                         {item.desc}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
                </>
              ))}
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Insight2;
